var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: #1d1d1b;\n      }\n    ")),React.createElement("path",{"className":"a","d":"M7.82,0H0V15H11V3.16ZM1,14V1H6.5V4.5H10V14Z","key":1})]);
}

File.defaultProps = {"viewBox":"0 0 11 15"};

module.exports = File;

File.default = File;
